"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_TYPES = void 0;
exports.QUESTION_TYPES = ["scale0_10", "scale1_10", "ranking", "categorical", "numeric", "boolean", "opentext"];
